import { useEffect, useState } from 'react'

const OFFER_DURATION_SECONDS = 15 * 60

export function useOfferCountdown(): string {
  const [secondsLeft, setSecondsLeft] = useState(OFFER_DURATION_SECONDS)

  useEffect(() => {
    const timer = window.setInterval(() => {
      setSecondsLeft((current) => Math.max(current - 1, 0))
    }, 1000)

    return () => window.clearInterval(timer)
  }, [])

  const minutes = Math.floor(secondsLeft / 60).toString().padStart(2, '0')
  const seconds = (secondsLeft % 60).toString().padStart(2, '0')

  return `${minutes}:${seconds}`
}
